import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

interface MobileWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const MobileWrapper: React.FC<MobileWrapperProps> = ({ children, className = '' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const getResponsiveClasses = () => {
    let classes = className;
    
    if (isMobile) {
      classes += ' mobile-content';
    } else if (isTablet) {
      classes += ' tablet-content';
    } else {
      classes += ' desktop-content';
    }
    
    return classes;
  };

  return (
    <Box 
      className={getResponsiveClasses()}
      sx={{
        padding: {
          xs: 2, // 16px on mobile
          sm: 3, // 24px on tablet
          md: 4, // 32px on desktop
        },
        marginTop: {
          xs: 8, // 64px on mobile (header height)
          sm: 8, // 64px on tablet
          md: 8, // 64px on desktop
        },
        marginBottom: {
          xs: 10, // 80px on mobile (bottom nav height)
          sm: 0,  // No bottom nav on tablet+
          md: 0,  // No bottom nav on desktop
        },
        minHeight: {
          xs: 'calc(100vh - 144px)', // Full height minus header and bottom nav
          sm: 'calc(100vh - 64px)',  // Full height minus header only
          md: 'calc(100vh - 64px)',  // Full height minus header only
        },
      }}
    >
      {children}
    </Box>
  );
};

export default MobileWrapper;

